import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStylesSmall } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";

let supplierOptions = [];
let parentSupplierOptions = [];
function PartnerDelegateTableRow({ index, level, parentSuppliers, secondarySuppliers, buyerCompanyId, handleSubmit, setError, t, setAdd, setErrorValue, oddIdx }) {
	const [supplierKey, setSupplierKey] = useState(0);
	const [supplierSelected, setSupplierSelected] = useState({ name: "supplierKey", label: "", value: 0 });
	const [supplierLoaded, setSupplierLoaded] = useState(false);
	const [parentSupplierKey, setParentSupplierKey] = useState(0);
	const [parentDelegateKey, setParentDelegateKey] = useState(0);
	const [parentSupplierSelected, setParentSupplierSelected] = useState({ name: "delegateKey", label: "", value: 0 });
	const [parentSupplierLoaded, setParentSupplierLoaded] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);
	const today = new Date().toISOString().split("T")[0];
	let startDate = today;
	let endDate = "";
	const [dates, setDates] = useState({ startDate: startDate, endDate: endDate });

	useEffect(() => {
		if (level > 1) {
			setParentSupplierValues(parentSuppliers);
		}
		if (level === 1) {
			setSupplierValues(secondarySuppliers);
		}

	}, []);

	function fetchPartners(supplierId, clientId) {
		setErrorValue("");
		if ((!supplierId || supplierId === 0) && (!clientId || clientId === 0)) {
			return;
		}

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				supplierCompanyId: supplierId,
				clientCompanyId: clientId,
				includeInactivePartner: true
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartners", "/Service/CompanyService/GetPartners", requestOptions, fetchSupplierSuccess, fetchPartnerFail);
		} catch (error) {
			throw new Error(error.message);
		}
	}
	function fetchSupplierSuccess(responseData) {
		let getPartnersResponse;
		if (responseData) {
			getPartnersResponse = responseData.getPartnersResponse;
			if (getPartnersResponse && getPartnersResponse.errorCode === "0") {
				if (getPartnersResponse.partnerList) {
					setSupplierValues(getPartnersResponse.partnerList.slice());
				}
			} else if (getPartnersResponse && getPartnersResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnersResponse) {
				setErrorValue(t("error.error") + " " + getPartnersResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}

	function fetchPartnerFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.partnerNotRetrieved"));
	}

	function setSupplierValues(supplierList) {
		let supplierValue = {};
		supplierOptions = [];
		supplierOptions.push({ label: "", value: 0 });
		if (supplierList && supplierList.length > 0) {
			supplierList.map((aSupplier) => {
				if (aSupplier.companyId != buyerCompanyId) {
					supplierValue.label = aSupplier.companyName + ', ' + (aSupplier.city ? aSupplier.city + ', ' : '') + aSupplier.stateCode + ', ' + aSupplier.countryCode;
					supplierValue.value = aSupplier.companyId;
					supplierOptions.push(supplierValue);
					supplierValue = {};
				}
			});
		}
		setSupplierLoaded(true);
		setSupplierSelected({ ...supplierSelected, label: "", value: 0 });
	}

	const supplierHandler = (selectedOption, action) => {
		let selectedSupplierKey = selectedOption ? selectedOption.value : 0;
		let selectedSupplierName = selectedOption ? selectedOption.label : "";
		setSupplierKey(selectedSupplierKey);
		setSupplierSelected({ ...supplierSelected, label: selectedSupplierName, value: selectedSupplierKey });
	}

	function setParentSupplierValues(parentSupplierList) {
		let parentSupplierValue = {};
		parentSupplierOptions = [];
		parentSupplierOptions.push({ label: "", value: 0 });
		if (parentSupplierList && parentSupplierList.length > 0) {
			parentSupplierList.map((aParentSupplier) => {
				//parentSupplierValue.label = aParentSupplier.companyName + ', ' + (aParentSupplier.city ? aParentSupplier.city + ', ' : '') + aParentSupplier.stateCode + ', ' + aParentSupplier.countryCode;
				parentSupplierValue.label = aParentSupplier.companyName;
				parentSupplierValue.value = aParentSupplier.delegateKey + "-" + aParentSupplier.companyId;
				parentSupplierOptions.push(parentSupplierValue);
				parentSupplierValue = {};
			});
		}
		setParentSupplierLoaded(true);
		setParentSupplierSelected({ ...parentSupplierSelected, label: "", value: 0 });
	}
	const parentSupplierHandler = (selectedOption, action) => {
		let selectedKeys = selectedOption ? selectedOption.value : "0";
		let selectedSupplierName = selectedOption ? selectedOption.label : "";

		let keys = selectedKeys.split("-");
		if (keys.length >= 2) {
			setParentDelegateKey(parseInt(keys[0]));
			let psupplierKey = parseInt(keys[1]);
			setParentSupplierKey(psupplierKey);
			if (psupplierKey > 0) {
				fetchPartners(0, psupplierKey);
			} else {
				setSupplierValues([]);
			}
		}else{
			setParentDelegateKey(0);
			setParentSupplierKey(0);
			setSupplierValues([]);
		}

		setParentSupplierSelected({ ...parentSupplierSelected, label: selectedSupplierName, value: selectedKeys });
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	
	function submitRow() {
		setError("");
		let errors = "";
		setIsSubmit(true);
		let startDate;
		let endDate;
		if (!dates.startDate) {
			errors = t("error.startdateReqd");
			setIsSubmit(false);
		}
		if(dates.startDate instanceof Object){
			startDate = dates.startDate.getTime();
		} else {
			startDate = new Date(dates.startDate).getTime();
		}
		if(dates.endDate){
			if(dates.endDate instanceof Object){
				endDate = dates.endDate.getTime();
			} else {
				endDate = new Date(dates.endDate).getTime();
			}
			if (startDate > endDate) {
		    	errors +=  t("error.endDateBeforeStartDate");
		    	setIsSubmit(false);
	  		}
	  	}
		if (level > 1 && (!parentSupplierKey || parentSupplierKey === 0)) {
			errors += t("error.parentSupplier.Reqd");
			setIsSubmit(false);

		} else if (!supplierKey || supplierKey === 0) {
			errors += t("error.supplier.Reqd");
			setIsSubmit(false);
		} else {
			let initialValues = {
				partnerKey: supplierKey,
				parentDelegateKey: parentDelegateKey,
				parentSupplierKey: parentSupplierKey,
				startDate: dates.startDate,
				endDate: dates.endDate,
			};
			handleSubmit(1, initialValues, submitComplete);
		}
		setError(errors);
	}
	
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	
	const valueHandler = (e) => {
		const { name, value } = e.target;
		if (typeof value === 'undefined') {
			value = "";
		}
		setDates({ ...dates, [name]: value });
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				{level > 1 && parentSupplierLoaded ? <Select
					name="delegateKey"
					options={parentSupplierOptions}
					onChange={parentSupplierHandler}
					placeholder={""}
					value={parentSupplierSelected}
					isSearchable={parentSupplierLoaded}
					isClearable={parentSupplierLoaded}
					className="myselect"
					inputId="supplierKey-input"
					styles={ddStylesSmall}
				/>
					: <></>}
			</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				{supplierLoaded ? <Select
					name="supplierKey"
					options={supplierOptions}
					onChange={supplierHandler}
					placeholder={""}
					value={supplierSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="supplierKey-input"
					styles={ddStylesSmall}
				/>
					: <></>}
			</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<input
					type="date"
					name="startDate"
					id="startDate"
					value={dates.startDate || today}
					onChange={valueHandler}
					className="form-control rounded-pill shadow-sm px-4 "
					max={today}
				/>
			</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<input
					type="date"
					name="endDate"
					id="endDate"
					value={dates.endDate}
					onChange={valueHandler}
					className="form-control rounded-pill shadow-sm px-4 "
				/>
			</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}></td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default PartnerDelegateTableRow;